<dx-load-panel [visible]="loading" shadingColor="rgba(0,0,0,0.4)"></dx-load-panel>
<app-side-nav-outer-toolbar title="{{ appInfo.title }}">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</app-side-nav-outer-toolbar>
